import {createFeatureSelector, createSelector} from "@ngrx/store";
import {CoreState, STATE_KEY_CORE} from "@core/store/core.reducers";

const state = createFeatureSelector<CoreState>(STATE_KEY_CORE)

const isOnline = createSelector(
  state,
  state => state.isOnline
)

const isOffline = createSelector(
  isOnline,
  isOnline => !isOnline
)

export const CoreSelectors = {
  isOnline,
  isOffline
}
